const dev = {
  API_ENDPOINT_URL: process.env.REACT_APP_API_URL || 'http://localhost:3001'
};

const prod = {
  // El build de produccion se hace con `docker compose build`, que pasa
  // REACT_APP_API_URL como build arg (ver docker-compose.prod.yml). Sin el arg
  // cae al dominio de prod, que es como venia funcionando: asi el stack de dev
  // (dev.sistema.brocsoft.com) apunta a su propia API sin tocar este archivo,
  // y un build sin arg nunca queda apuntando a localhost.
  API_ENDPOINT_URL:
    process.env.REACT_APP_API_URL || 'https://api.sistema.brocsoft.com'
};

const test = {
  API_ENDPOINT_URL: '/api'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
